import { DefaultPage } from '@shared/restaurant/enums';

export function getWaitFieldsOptions(customerLabel: string) {
  return [
    {
      name: 'Quoted Time',
      id: 'quoted_time',
      hover: 'Show the quoted time and a timer that shows how much time is left until you reach that time.',
    },
    {
      name: 'Arrival Time',
      id: 'arrival_time',
      hover: 'Show the arrival time as a column in your waitlist.',
    },
    {
      name: 'Wait Time',
      id: 'wait_time',
      hover: 'Show how long someone has been waiting as a column in your waitlist.',
    },
    {
      name: 'Make Notes Field its Own Column',
      id: 'note_column',
      hover: `Instead of listing Notes with the  name, make it into its own column on the waitlist.`,
    },
    {
      name: 'Estimated Wait Times',
      id: 'estimated_waits',
      hover: `Show an estimate of how long your current wait time is above your waitlist. This is based on the current list size and factors in the time of day, day of week, and  size (if applicable). This will show no data until you have served at least 100.`,
    },
    {
      name: 'Position In Line',
      id: 'position_in_line',
      hover: `Add a new column on your waitlist page with the position in line for each ${customerLabel}.`
    },
    {
      name: 'Order ID instead of Name field',
      id: 'numericOderId',
      hover: 'Replace the \'Name\' field with a numeric \'Order ID\' field.',
    },
  ];
};
export const AUTO_REMOVE_OPTIONS = [
  {
    name: '1 hour',
    value: 1,
  },
  {
    name: '3 hours',
    value: 3,
  },
  {
    name: '6 hours',
    value: 6,
  },
  {
    name: '12 hours',
    value: 12,
  },
  {
    name: '18 hours',
    value: 18,
  },
  {
    name: '24 hours',
    value: 24,
  },
  {
    name: '2 days',
    value: 48,
  },
  {
    name: '3 days',
    value: 72,
  },
  {
    name: '1 week',
    value: 168,
  },
  {
    name: 'Never',
    value: 9000,
  }
];
export const CUSTOMER_LABEL_OPTIONS = [
  'party',
  'customer',
  'attendee',
  'diner',
  'driver',
  'group',
  'guest',
  'load',
  'member',
  'participant',
  'patient',
  'player',
  'shopper',
  'student',
  'trailer',
  'user',
  'order',
];
export const QUOTED_LABEL_OPTIONS = [
  'quoted time',
  'quoted',
  'estimated time',
  'estimated',
  'ETA',
  'scheduled time',
  'scheduled'
];

export const NOTIFICATION_TIME_OPTIONS = [
  'Relative',
  'Absolute',
];

export const DEFAULT_PAGE_OPTIONS = [
  {value: DefaultPage.waitlist, name: 'Waitlist'},
  {value: DefaultPage.reservation, name: 'Reservations'},
];
